import { memo, FC, Dispatch, SetStateAction, useMemo } from 'react'
import { Fade, Flex, FlexProps, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react'

import { CitizenFilterKeyString } from 'CitizenProfile/types'
import { CITIZEN_INITIAL_FILTER } from 'CitizenProfile/constants/pages/citizens'
import { getCitizenFilterFeedbacks } from 'CitizenProfile/utils/getCitizenFilterFeedbacks'
import { RefreshButton } from 'components'
import { getMetadatasFilterTagsFeedbacks } from 'components/filters/MetadatasFilterTemplate/utils/getMetadatasFilterTagsFeedbacks'
import { getFrequenciesActivitiesTypesNamesFilterFeedbacks } from 'components/filters/FrequencieActivitiesTypesFilterTemplate/utils/getFrequenciesActivitiesTypesNamesFilterFeedbacks'
import { ActivityTypeKeyString } from 'Activities/types'

type Props = FlexProps & {
  tagBg?: 'bgContainer' | 'bgContent'
  activityType?: ActivityTypeKeyString
  citizenFilter: CitizenFilterKeyString
  setCitizenFilter: Dispatch<SetStateAction<CitizenFilterKeyString>>
}

const CitizenFilterTags: FC<Props> = ({
  tagBg = 'bgContent',
  activityType,
  citizenFilter,
  setCitizenFilter,
  ...flexProps
}) => {
  const filtersWithValue = useMemo(() => {
    return Object.entries(citizenFilter).filter(([key]) => {
      if (CITIZEN_INITIAL_FILTER[key] === undefined) return false

      return JSON.stringify(citizenFilter[key]) !== JSON.stringify(CITIZEN_INITIAL_FILTER[key])
    })
  }, [citizenFilter])

  function resetFilterByKey(key: string) {
    setCitizenFilter({ ...citizenFilter, [key]: CITIZEN_INITIAL_FILTER[key] })
  }

  function resetAllFilters() {
    setCitizenFilter(CITIZEN_INITIAL_FILTER)
  }

  function setFilterFeedbackInTagByKey(key: string, value: any) {
    const citizenFilterTagsFeedbacks = getCitizenFilterFeedbacks(value)
    const metadatasFilterTagsFeedbacks = getMetadatasFilterTagsFeedbacks({
      metadata: activityType,
      filter: citizenFilter,
    })
    const frequencieActivitiesTypesFilterTagsFeedbacks = getFrequenciesActivitiesTypesNamesFilterFeedbacks(value)

    const filterTagsFeedbacks: CitizenFilterKeyString = {
      activity_type_name: `Tipo de atividade: ${value}`,
      place_name: `Local: ${value}`,
      ...frequencieActivitiesTypesFilterTagsFeedbacks,
      ...metadatasFilterTagsFeedbacks,
      ...citizenFilterTagsFeedbacks,
    }

    return filterTagsFeedbacks[key]
  }

  if (filtersWithValue.length === 0) return null

  return (
    <Fade in>
      <Flex align="center" gap={2} flexWrap="wrap" {...flexProps}>
        {filtersWithValue.map(([key, value]) => {
          const filterValue = setFilterFeedbackInTagByKey(key, value as string)
          if (!filterValue) return null
          return (
            <Tag bg={tagBg} key={key} variant="filter-tags">
              <TagLabel>{setFilterFeedbackInTagByKey(key, value as string)}</TagLabel>
              <TagCloseButton onClick={() => resetFilterByKey(key)} />
            </Tag>
          )
        })}

        <RefreshButton onClick={resetAllFilters}>Limpar filtros</RefreshButton>
      </Flex>
    </Fade>
  )
}

export default memo(CitizenFilterTags)
